(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["klaviyo-landing"]) return;
  try {
    
    console.log("signup-page")
  window._learnq = window._learnq || [];
  window._learnq.push(['account', 'TdqQvM']);
  console.log(window._learnq);

  setTimeout(function () {
    window._learnq.push(['form', 'UWb6rh']);
  }, 1000);

  } catch(e) { console.error(e); }
})();
})();
